const FALLBACKS = {
  shortName: "SSA Techno",
  legalName: "SSA Techno Construction Pvt. Ltd.",
  tagline: "Better Technology for Better Tomorrow",
};

/** Branding fields from the about API: short_name, name, tagline */
export function getCompanyBranding(about = {}) {
  const shortName = about.shortName?.trim() || FALLBACKS.shortName;
  const legalName = about.name?.trim() || FALLBACKS.legalName;
  const tagline = about.tagline?.trim() || FALLBACKS.tagline;
  const legalSuffix = legalName.startsWith(shortName)
    ? legalName.slice(shortName.length).trim()
    : "";

  return { shortName, legalName, tagline, legalSuffix };
}

export { FALLBACKS as COMPANY_FALLBACKS };
